import React, { useState, useEffect } from "react";
import "./../../../../assets/css/purchase/form.css";
import Select from "react-select";

// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import ArModal from "../../../components/Modal/ArModal";
import InvoiceModal from "../../../components/Modal/InvoiceModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";

// Utils
import {
  getDataWithComp,
  getByDocId,
  getAlert,
  formatCurrency,
  parseCurrency,
  randomDelay,
  getMaxDocNo,
  insertData,
  updateData,
  deleteData,
} from "../../../../utils/SamuiUtils";

import {
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
} from "../../../../utils/DateUtils";

function Form({ callInitialize, mode, name, maxDocNo, setMaxDocNo, setMode }) {
  const [formMasterList, setFormMasterList] = useState({
    docId: "",
    docNo: maxDocNo || "",
    docDate: formatThaiDateUi(moment()),
    docStatus: 1,
    docRemark1: "",
    docRemark2: "",
    refDoc: "",
    refDocDate: null,
    refDocRemark: "",
    arID: "",
    arCode: "",
    arName: "",
    arAdd1: "",
    arAdd2: "",
    arAdd3: "",
    arProvince: "",
    arZipcode: "",
    arTaxNo: "",
    arContact1: "",
    arContact2: "",
    arTel1: "",
    arTel2: "",
    empName: "",
    placeDelivery: "",
    placeDelivery2: "",
    discountValue: 0,
    discountValueType: "2",
    isVat: 1,
    createdDate: getCreateDateTime(),
    createdByName: window.localStorage.getItem("name") || "",
    createdById: window.localStorage.getItem("emp_id") || "",
    updateDate: null,
    updateByName: "",
    updateById: "",
  });

  const [formDetailList, setFormDetailList] = useState([]);
  // const [tbDocType, setTbDocType] = useState([]);
  // const [tbTransType, setTbTransType] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [saleman, setSalemanList] = useState([]);
  const [invDataList, setInvDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] = useState("2");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(true);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะเอกสาร
  const [statusName, setStatusName] = useState("");
  const [statusColour, setStatusColour] = useState("");

  // สำหรับตัวแปรดักป้องกันการกดซ้ำ
  const [isSubmitting, setIsSubmitting] = useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [loading, setLoading] = useState(false);

  const options = saleman
    .slice() // ป้องกันไม่ให้แก้ของเดิม
    .sort((a, b) => a.Emp_Id - b.Emp_Id) // เรียงจากน้อยไปมาก
    .map((ap) => ({
      value: ap.Emp_Id,
      label: `${ap.Emp_Prefix} ${ap.Emp_Name}`,
      empName: ap.Emp_Name, // เพิ่มชื่อเฉพาะสำหรับค้นหา
    }));

  useEffect(() => {
    initialize();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const initialize = async () => {
    try {
      setLoading(true);

      // TODO: Load document types if needed
      // const docTypeList = await getDocType(2);
      // if (docTypeList && docTypeList.length > 0) {
      //   setTbDocType(docTypeList);
      // }

      // const transTypeList = await getTransType();
      // if (transTypeList && transTypeList.length > 0) {
      //   setTbTransType(transTypeList);
      // }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const salemanList = await getDataWithComp(
        "Tb_Set_Employee",
        `AND  Emp_Position = ${4} ORDER BY Emp_Id ASC`
      );
      if (salemanList && salemanList.length > 0) {
        setSalemanList(salemanList);
      }

      // โหลดข้อมูลใบกำกับภาษีที่ยังไม่มีใบลดหนี้
      const invDataList = await getDataWithComp(
        "API_0701_SO_H",
        " AND Doc_Status <> 13 ORDER BY Doc_No DESC"
      );
      setInvDataList(invDataList || []); // Always set, even if empty
      console.debug("Loaded Invoice Data:", invDataList);
      const itemDataList = await getDataWithComp(
        "View_Set_Item",
        "ORDER BY Item_Id ASC"
      );
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      getAlert("FAILED", error.message);
    }
  };

  const getModelByNo = async (arDataList) => {
    try {
      setLoading(true);

      const findMaster = await getDataWithComp("CR_H", "");
      const fromDatabase = findMaster.find((cr) => cr.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลลูกค้าด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ar) => ar.AR_Id === fromDatabase.AR_ID
      );
      if (!fromViewAr) {
        setLoading(false);
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0901_CR_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusName(fromView?.DocStatus_Name || "");
      setStatusColour(fromView?.DocStatus_Colour || "");

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "CR_D",
        fromDatabase.Doc_Id,
        "ORDER BY Line ASC"
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) => ({
          dtId: item.DT_Id,
          docId: item.Doc_ID,
          line: item.Line,
          itemId: item.Item_Id,
          itemCode: item.Item_Code,
          itemName: item.Item_Name,
          itemQty: formatCurrency(parseCurrency(item.Item_Qty) || 0),
          itemUnit: item.Item_Unit,
          itemPriceUnit: formatCurrency(parseCurrency(item.Item_Price_Unit) || 0),
          itemDiscount: formatCurrency(parseCurrency(item.Item_Discount) || 0),
          itemDisType: String(item.Item_DisType),
          itemTotal: parseCurrency(item.Item_Total) || 0,
          itemStatus: item.Item_Status,
          whId: item.WH_Id,
          itemOnHand: "-",
        }));

        setFormDetailList(newFormDetails);
      }

      setFormMasterList({
        docId: fromDatabase.Doc_Id,
        compId: fromDatabase.Comp_Id,
        docNo: fromDatabase.Doc_No,
        docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
        docStatus: fromDatabase.Doc_Status,
        docRemark1: fromDatabase.Doc_Remark1 || "",
        docRemark2: fromDatabase.Doc_Remark2 || "",
        refDoc: fromDatabase.Doc_INV_No || "",
        refDocDate: formatThaiDateUi(fromDatabase.Doc_DueDate || null),
        refDocRemark: fromDatabase.Ref_Doc || "",
        arID: fromDatabase.AR_ID,
        arCode: fromDatabase.AR_Code,
        arName: fromViewAr.AR_Name,
        arAdd1: fromViewAr.AR_Add1,
        arAdd2: fromViewAr.AR_Add2,
        arAdd3: fromViewAr.AR_Add3,
        arProvince: fromViewAr.AR_Province,
        arZipcode: fromViewAr.AR_Zipcode,
        arTaxNo: fromViewAr.AR_Tax_No,
        arContact1: fromViewAr.AR_Contact1 || "",
        arContact2: fromViewAr.AR_Contact2 || "",
        arTel1: fromViewAr.AR_Tel1 || "",
        arTel2: fromViewAr.AR_Tel2 || "",
        empName: fromDatabase.EmpName || "",
        discountValue: fromDatabase.Discount_Value || 0,
        discountValueType: fromDatabase.Discount_Value_Type || "2",
        isVat: fromDatabase.IsVat,
        createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
        createdByName: fromDatabase.Created_By_Name,
        createdById: fromDatabase.Created_By_Id,
        updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
        updateByName: fromDatabase.Update_By_Name,
        updateById: fromDatabase.Update_By_Id,
      });

      setIsVatChecked(fromDatabase.IsVat === 1);
      setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));

      setLoading(false);
    } catch (error) {
      setLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  // ฟังก์ชันจัดการเปลี่ยนแปลง Master
  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    setFormMasterList({ ...formMasterList, [name]: value });
  };

  const handleChangeDateMaster = (date, name) => {
    setFormMasterList({
      ...formMasterList,
      [name]: formatThaiDateUi(date),
    });
  };

  // AR Modal
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);

  // Invoice Modal
  const [showInvModal, setShowInvModal] = useState(false);
  const handleInvShow = () => {
    // ตรวจสอบว่าเลือกลูกค้าแล้วหรือยัง
    if (!formMasterList.arID || formMasterList.arID === "") {
      getAlert("FAILED", "กรุณาเลือกลูกค้าก่อนอ้างอิงใบกำกับภาษี");
      return;
    }
    setShowInvModal(true);
  };
  const handleInvClose = () => setShowInvModal(false);

  // Item Modal
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => {
    setShowItemModal(true);
  };
  const handleItemClose = () => {
    console.debug("handleItemClose called");
    setShowItemModal(false);
  };

  const onRowSelectAr = async (arSelected) => {
    try {
      setFormMasterList({
        ...formMasterList,
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_Tax_No,
        arContact1: arSelected.AR_Contact1 || "",
        arContact2: arSelected.AR_Contact2 || "",
        arTel1: arSelected.AR_Tel1 || "",
        arTel2: arSelected.AR_Tel2 || "",
        refDoc: "",
        refDocDate: null,
        refDocRemark: "",
        empName: "",
      });
      handleArClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  const onRowSelectInv = async (invSelected) => {
    try {
      // ถ้ามี Sale_name (ID) ให้ค้นหาชื่อพนักงานขายจาก Emp_Id
      let empName = "";
      if (invSelected.Sale_name) {
        const empData = await getDataWithComp(
          "Tb_Set_Employee",
          `AND Emp_Id = ${invSelected.Sale_name}`
        );
        if (empData && empData.length > 0) {
          empName = empData[0].Emp_Name || "";
        }
      }
      
      setFormMasterList({
        ...formMasterList,
        refDoc: invSelected.Doc_No || invSelected.Doc_INV_No,
        refDocDate: formatThaiDateUi(invSelected.Doc_Date),
        refDocRemark: "",
        arID: invSelected.AR_ID,
        arCode: invSelected.AR_Code,
        arName: invSelected.AR_Name,
        arAdd1: invSelected.AR_Add1,
        arAdd2: invSelected.AR_Add2,
        arAdd3: invSelected.AR_Add3,
        arProvince: invSelected.AR_Province,
        arZipcode: invSelected.AR_Zipcode,
        arTaxNo: invSelected.AR_Tax_No,
        arContact1: invSelected.AR_Contact1 || "",
        arContact2: invSelected.AR_Contact2 || "",
        arTel1: invSelected.AR_Tel1 || "",
        arTel2: invSelected.AR_Tel2 || "",
        empName: empName,
        placeDelivery: invSelected.Place_Delivery || "",
        placeDelivery2: invSelected.Place_Delivery2 || "",
      });
      handleInvClose();
    } catch (error) {
      getAlert("FAILED", error);
    }
  };

  // Item Management
  const onRowSelectItem = (item) => {
    
    // ถ้าเป็น array ให้เอาตัวแรก
    const selectedItem = Array.isArray(item) ? item[0] : item;
    
    if (!selectedItem) {
      console.error("No item selected");
      return;
    }
    
    // Debug: ดูข้อมูลที่เลือก
    console.debug("Selected item from modal:", selectedItem);
    
    const newItem = {
      line: formDetailList.length + 1,
      itemId: selectedItem.Item_Id,
      itemCode: selectedItem.Item_Code,
      itemName: selectedItem.Item_Name,
      itemQty: "1.00",
      itemUnit: selectedItem.Item_Unit_OUT || selectedItem.Item_Unit_ST || selectedItem.Item_Unit || "",
      itemPriceUnit: formatCurrency(selectedItem.Item_Price || 0),
      itemDiscount: "0.00",
      itemDisType: "2",
      itemTotal: parseCurrency(selectedItem.Item_Price) || 0,
      itemOnHand: "-",
    };
    
    console.debug("New item to add:", newItem);
    setFormDetailList([...formDetailList, newItem]);
    handleItemClose();
  };

  const onRowSelectItem02 = () => {
    console.debug("Adding empty item (unspecified item)");
    const newItem = {
      line: formDetailList.length + 1,
      itemId: "",
      itemCode: "-",
      itemName: "",
      itemQty: "1.00",
      itemUnit: "",
      itemPriceUnit: "0.00",
      itemDiscount: "0.00",
      itemDisType: "2",
      itemTotal: 0,
      itemOnHand: "-",
    };
    setFormDetailList([...formDetailList, newItem]);
    handleItemClose();
  };

  const handleRemoveItem = (index) => {
    const newList = formDetailList.filter((_, i) => i !== index);
    setFormDetailList(newList);
  };

  const handleDuplicateRow = (index) => {
    const itemToCopy = { ...formDetailList[index] };
    const newItem = {
      ...itemToCopy,
      line: formDetailList.length + 1,
    };
    setFormDetailList([...formDetailList, newItem]);
  };

  const handleItemChange = (index, field, value) => {
    const updatedList = [...formDetailList];
    updatedList[index][field] = value;

    // คำนวณ itemTotal
    if (
      field === "itemQty" ||
      field === "itemPriceUnit" ||
      field === "itemDiscount" ||
      field === "itemDisType"
    ) {
      const qty = parseCurrency(updatedList[index].itemQty) || 0;
      const price = parseCurrency(updatedList[index].itemPriceUnit) || 0;
      const discount = parseCurrency(updatedList[index].itemDiscount) || 0;
      const disType = updatedList[index].itemDisType;

      let total = qty * price;
      if (disType === "2") {
        total -= (discount / 100) * total;
      } else {
        total -= discount;
      }
      updatedList[index].itemTotal = total;
    }

    setFormDetailList(updatedList);
  };

  // Handle focus/blur for formatting
  const handleFocus = (e) => {
    // ตรวจสอบว่ามี target หรือไม่ (เป็น event object)
    if (e && e.target) {
      const value = e.target.value;
      if (value) {
        e.target.value = parseCurrency(value).toString();
      }
    }
  };

  const handleBlur = (e) => {
    // ตรวจสอบว่ามี target หรือไม่ (เป็น event object)
    if (e && e.target) {
      const value = e.target.value;
      if (value) {
        e.target.value = formatCurrency(parseCurrency(value));
      }
    }
  };

  // คำนวณยอดรวม
  useEffect(() => {
    calculateTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [formDetailList, formMasterList.discountValue, selectedDiscountValueType, isVatChecked]);

  const calculateTotal = () => {
    const total = formDetailList.reduce(
      (sum, item) => sum + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);

    const discountValue = parseCurrency(formMasterList.discountValue) || 0;
    let discount = 0;
    if (selectedDiscountValueType === "2") {
      discount = (discountValue / 100) * total;
    } else {
      discount = discountValue;
    }
    setReceiptDiscount(discount);

    const afterDiscount = total - discount;
    setSubFinal(afterDiscount);

    let vat = 0;
    if (isVatChecked) {
      vat = afterDiscount * 0.07;
    }
    setVatAmount(vat);

    const grand = afterDiscount + vat;
    setGrandTotal(grand);
  };

  // Handlers สำหรับ Summary component
  const handleCheckboxChange = (e) => {
    setSelectedDiscountValueType(e.target.value);
  };

  const handleVatChange = () => {
    setIsVatChecked(!isVatChecked);
  };

  // Submit & Update & Cancel
  const handleSubmit = async () => {
    try {
      if (isSubmitting) return;
      setIsSubmitting(true);

      await randomDelay();

      // หาค่าสูงสุดของ DocNo
      const findMaxDocNo = await getDataWithComp(
        "CR_H",
        "ORDER BY Doc_Id DESC"
      );
      const maxDoc = getMaxDocNo(findMaxDocNo, "CR");
      let newMaxDoc = maxDoc;

      if (!formMasterList.arID && !formMasterList.arCode) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        setIsSubmitting(false);
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        setIsSubmitting(false);
        return;
      }

      // Validate items
      for (const item of formDetailList) {
        if (item.itemCode && item.itemCode !== "-") {
          if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
            getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName || "ที่ไม่มีชื่อ"}`);
            setIsSubmitting(false);
            return;
          }
          if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
            getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName || "ที่ไม่มีชื่อ"}`);
            setIsSubmitting(false);
            return;
          }
        }
      }

      // บันทึก CR_H (Master)
  const masterField = "Comp_Id, Doc_No, Doc_Date, Doc_Status, Doc_Code, Doc_Remark1, Doc_Remark2, Doc_INV_No, Doc_DueDate, AR_ID, AR_Code, AR_Name, AR_Tax_No, AR_Add1, AR_Add2, AR_Add3, AR_Province, AR_Zipcode, AR_Contact1, AR_Contact2, AR_Tel1, AR_Tel2, EmpName, Discount_Value, Discount_Value_Type, IsVat, Ref_Doc, Created_By_Id, Created_By_Name, Created_Date";
      const masterValues = [
        window.localStorage.getItem("company"),
        newMaxDoc,
        formatThaiDateUiToDate(formMasterList.docDate),
        1,
        "",
        formMasterList.docRemark1,
        formMasterList.docRemark2,
        formMasterList.refDoc || "",
        formMasterList.refDocDate ? formatThaiDateUiToDate(formMasterList.refDocDate) : null,
        formMasterList.arID,
        formMasterList.arCode,
        formMasterList.arName,
        formMasterList.arTaxNo,
        formMasterList.arAdd1 || "",
        formMasterList.arAdd2 || "",
        formMasterList.arAdd3 || "",
        formMasterList.arProvince || "",
        formMasterList.arZipcode || "",
        formMasterList.arContact1 || "",
        formMasterList.arContact2 || "",
        formMasterList.arTel1 || "",
        formMasterList.arTel2 || "",
        formMasterList.empName,
        parseCurrency(formMasterList.discountValue),
        selectedDiscountValueType,
        isVatChecked ? 1 : 0,
        formMasterList.refDocRemark || "",
        window.localStorage.getItem("emp_id"),
        window.localStorage.getItem("name"),
        moment().format("YYYY-MM-DD HH:mm:ss")
      ];

      const resultMaster = await insertData("CR_H", masterField, masterValues);

      console.debug("Insert Result:", resultMaster);

      if (!resultMaster || resultMaster.status !== "OK") {
        getAlert("FAILED", "ไม่สามารถบันทึกข้อมูลหลักได้");
        setIsSubmitting(false);
        return;
      }

      // หา Doc_Id ที่เพิ่งสร้าง โดยใช้ Doc_No
      const findInserted = await getDataWithComp("CR_H", `AND Doc_No='${newMaxDoc}'`);
      
      if (!findInserted || findInserted.length === 0) {
        console.error("Cannot find inserted CR_H with Doc_No:", newMaxDoc);
        getAlert("FAILED", "ไม่พบข้อมูลที่เพิ่งบันทึก");
        setIsSubmitting(false);
        return;
      }

      const docId = findInserted[0].Doc_Id;
      console.debug("Found Doc_Id:", docId);

      // บันทึก CR_D (Details)
      for (let i = 0; i < formDetailList.length; i++) {
        const item = formDetailList[i];
        const detailField = "Doc_ID, Line, Item_Id, Item_Code, Item_Name, Item_Qty, Item_Unit, Item_Price_Unit, Item_Discount, Item_DisType, Item_Total, Item_Status, WH_Id";
        const detailValues = [
          docId,
          i + 1,
          item.itemId || null,
          item.itemCode,
          item.itemName,
          parseCurrency(item.itemQty),
          item.itemUnit,
          parseCurrency(item.itemPriceUnit),
          parseCurrency(item.itemDiscount),
          item.itemDisType,
          parseCurrency(item.itemTotal),
          1,
          item.whId || null
        ];
        await insertData("CR_D", detailField, detailValues);
      }

      getAlert("OK", `บันทึกข้อมูลสำเร็จ เลขที่เอกสาร: ${newMaxDoc}`);
      setMaxDocNo(newMaxDoc);
      setMode("U");
      callInitialize();

      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleUpdate = async () => {
    try {
      if (isSubmitting) return;
      setIsSubmitting(true);

      await randomDelay();

      if (!formMasterList.arID) {
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        setIsSubmitting(false);
        return;
      }

      if (!formDetailList || formDetailList.length === 0) {
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        setIsSubmitting(false);
        return;
      }

      // อัพเดต CR_H (Master)
      const masterValues = {
        Doc_Date: formatThaiDateUiToDate(formMasterList.docDate),
        Doc_Code: "",
        Doc_Remark1: formMasterList.docRemark1,
        Doc_Remark2: formMasterList.docRemark2,
        Doc_INV_No: formMasterList.refDoc,
        Doc_DueDate: formMasterList.refDocDate ? formatThaiDateUiToDate(formMasterList.refDocDate) : null,
        AR_ID: formMasterList.arID,
        AR_Code: formMasterList.arCode,
        AR_Name: formMasterList.arName,
        AR_Tax_No: formMasterList.arTaxNo || "",
        AR_Add1: formMasterList.arAdd1 || "",
        AR_Add2: formMasterList.arAdd2 || "",
        AR_Add3: formMasterList.arAdd3 || "",
        AR_Province: formMasterList.arProvince || "",
        AR_Zipcode: formMasterList.arZipcode || "",
        AR_Contact1: formMasterList.arContact1 || "",
        AR_Contact2: formMasterList.arContact2 || "",
        AR_Tel1: formMasterList.arTel1 || "",
        AR_Tel2: formMasterList.arTel2 || "",
        EmpName: formMasterList.empName,
        Discount_Value: parseCurrency(formMasterList.discountValue),
        Discount_Value_Type: selectedDiscountValueType,
        IsVat: isVatChecked ? 1 : 0,
        Ref_Doc: formMasterList.refDocRemark || "",
        Update_By_Id: window.localStorage.getItem("emp_id"),
        Update_By_Name: window.localStorage.getItem("name"),
        Update_Date: moment().format("YYYY-MM-DD HH:mm:ss")
      };
      const masterWhere = { Doc_Id: formMasterList.docId };

      await updateData("CR_H", masterValues, masterWhere);

      // ลบรายการเก่าทั้งหมด
      await deleteData("CR_D", `WHERE Doc_ID=${formMasterList.docId}`);

      // บันทึก CR_D ใหม่
      for (let i = 0; i < formDetailList.length; i++) {
        const item = formDetailList[i];
        const detailField = "Doc_ID, Line, Item_Id, Item_Code, Item_Name, Item_Qty, Item_Unit, Item_Price_Unit, Item_Discount, Item_DisType, Item_Total, Item_Status, WH_Id";
        const detailValues = [
          formMasterList.docId,
          i + 1,
          item.itemId || null,
          item.itemCode,
          item.itemName,
          parseCurrency(item.itemQty),
          item.itemUnit,
          parseCurrency(item.itemPriceUnit),
          parseCurrency(item.itemDiscount),
          item.itemDisType,
          parseCurrency(item.itemTotal),
          1,
          item.whId || null
        ];
        await insertData("CR_D", detailField, detailValues);
      }

      getAlert("OK", "แก้ไขข้อมูลสำเร็จ");
      callInitialize();

      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCancel = async () => {
    try {
      if (isSubmitting) return;
      setIsSubmitting(true);

      await randomDelay();

      // อัพเดตสถานะเป็นยกเลิก (Doc_Status = 13)
      const cancelValues = {
        Doc_Status: 13,
        Cancel_By_Id: window.localStorage.getItem("emp_id"),
        Cancel_By_Name: window.localStorage.getItem("name"),
        Cancel_Date: moment().format("YYYY-MM-DD HH:mm:ss")
      };
      const cancelWhere = { Doc_Id: formMasterList.docId };

      await updateData("CR_H", cancelValues, cancelWhere);

      getAlert("OK", "ยกเลิกเอกสารสำเร็จ");
      callInitialize();
      setMode("U");

      setIsSubmitting(false);
    } catch (error) {
      setIsSubmitting(false);
      getAlert("FAILED", error.message || error);
    }
  };

  return (
    <>
      <Breadcrumbs
        page={maxDocNo}
        isShowStatus={mode === "U"}
        statusName={statusName}
        statusColour={statusColour}
        items={[
          { name: "บัญชี", url: "/credit-note" },
          { name: name, url: "/credit-note" },
          {
            name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
            url: "#",
          },
        ]}
        onHandleClick={() => {
          // TODO: Add report function
          console.debug("Generate report for", maxDocNo);
        }}
      />

      {/* Loading Spinner */}
      {loading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar" style={{ maxHeight: "80vh", overflowY: "auto" }}>
        {/* Row 1: วันที่เอกสาร, ลูกค้า, วันที่สร้างเอกสาร */}
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="arCode"
                  value={`${formMasterList.arCode || ""} ${formMasterList.arName || ""}`}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={formMasterList.docStatus !== 1 || mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                disabled={true}
              />
            </div>
          </div>
        </div>

        {/* Row 2: อ้างอิงใบกำกับภาษี, ที่อยู่, ผู้สร้างเอกสาร */}
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงใบกำกับภาษี</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleInvShow}
                  disabled={formMasterList.docStatus !== 1 || mode === "U"}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <InvoiceModal
              showInvModal={showInvModal}
              handleInvClose={handleInvClose}
              invDataList={invDataList}
              soDataList={[]}
              qtDataList={[]}
              onRowSelectInv={onRowSelectInv}
              arId={formMasterList.arID}
            />
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd1"
                value={formMasterList.arAdd1 || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                disabled={true}
              />
            </div>
          </div>
        </div>

        {/* Row 3: วันที่เอกสารอ้างอิง, ที่อยู่ (ต่อ), วันที่แก้ไขล่าสุด */}
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              <Datetime
                className="input-spacing-input-date"
                name="refDocDate"
                value={formMasterList.refDocDate || null}
                onChange={(date) => handleChangeDateMaster(date, "refDocDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{ readOnly: true, disabled: mode === "U" }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={`${formMasterList.arAdd2 || ""} ${formMasterList.arAdd3 || ""}`}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                disabled={true}
              />
            </div>
          </div>
        </div>

        {/* Row 4: จังหวัด/รหัสไปรษณีย์, ผู้แก้ไขเอกสาร */}
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                value={`${formMasterList.arProvince || ""} ${formMasterList.arZipcode || ""}`}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                disabled={true}
              />
            </div>
          </div>
        </div>

        {/* Row 5: เลขที่ภาษี, พนักงานขาย */}
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>พนักงานขาย</label>
              <div className="w-100">
                <Select
                  name="empName"
                  options={options}
                  value={
                    options.find((opt) => opt.empName === formMasterList.empName) || null
                  }
                  placeholder={formMasterList.empName || "เลือกพนักงานขาย"}
                  onChange={(selectedOption) =>
                    handleChangeMaster({
                      target: {
                        name: "empName",
                        value: selectedOption ? selectedOption.empName : "",
                      },
                    })
                  }
                  isDisabled={mode === "U" || !saleman || saleman.length === 0}
                />
              </div>
            </div>
          </div>
        </div>

        {/* Row 5.5: อ้างอิงเอกสาร */}
        <div className="row mt-1">
          <div className="col-3"></div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refDocRemark"
                value={formMasterList.refDocRemark || ""}
                onChange={handleChangeMaster}
                disabled={mode === "U"}
              />
            </div>
          </div>
        </div>
        {/* Row 6: รายละเอียยเอกสาร และ หมายเหตุสรุป */}
        <div className="row mt-3" style={{ borderTop: '1px solid #dee2e6', paddingTop: '10px' }}>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <textarea
                className="input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
                disabled={mode === "U"}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <textarea
                className="input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
                disabled={mode === "U"}
              />
            </div>
          </div>
        </div>

        {/* Item Table */}
        <div className="row mt-3">
          <div className="col-12">
            <ItemTable
              formDetailList={formDetailList}
              setFormDetailList={setFormDetailList}
              handleChangeDetail={handleItemChange}
              handleRemoveRow={handleRemoveItem}
              handleDuplicateRow={handleDuplicateRow}
              showItemModal={showItemModal}
              handleItemShow={handleItemShow}
              handleItemClose={handleItemClose}
              itemDataList={itemDataList}
              onRowSelectItem={onRowSelectItem}
              onRowSelectItem02={onRowSelectItem02}
              whDataList={[]}
              formatCurrency={formatCurrency}
              handleFocus={handleFocus}
              handleBlur={handleBlur}
              mode={mode}
              docStatus={formMasterList.docStatus}
              disabled={false}
            />
          </div>
        </div>

        {/* Summary */}
        <div className="row mt-3">
          <div className="col-12">
            <Summary
              formMasterList={formMasterList}
              handleChangeMaster={handleChangeMaster}
              selectedDiscountValueType={selectedDiscountValueType}
              handleCheckboxChange={handleCheckboxChange}
              receiptDiscount={receiptDiscount}
              formatCurrency={formatCurrency}
              totalPrice={totalPrice}
              subFinal={subFinal}
              isVatChecked={isVatChecked}
              handleVatChange={handleVatChange}
              vatAmount={vatAmount}
              grandTotal={grandTotal}
              disabled={false}
              disabledVat={false}
            />
          </div>
        </div>
      </div>

      {/* Form Action Footer */}
      <FormAction
        onSubmit={handleSubmit}
        onUpdate={handleUpdate}
        onCancel={handleCancel}
        docStatus={formMasterList.docStatus}
        mode={mode}
        disabled={false}
        footer={true}
      />
    </>
  );
}

export default Form;
